import React from "react"

export default function Anchor({classes, name})
{       
    const c = classes !== undefined ? ' '+classes : ''
    
    return (<a className={'anchor'+c} name={name}></a>)
}